module.exports = __webpack_public_path__ + "asset/image-free-f9b37a5c339fe7d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/component/plan/image/free.png
// module id = QNFe
// module chunks = 3